(()=>{
  const banner=document.querySelector('[data-cookie-banner]');
  if(!banner)return;
  const error= banner.querySelector('[data-cookie-error]');
  const inputs=[...banner.querySelectorAll('[data-cookie-purpose]')];
  let api;
  const show=()=>{banner.hidden=false;};
  const sync=()=>{
    const consent=api.currentVisitorConsent();
    inputs.forEach(input=>{input.checked=consent[input.dataset.cookiePurpose]==='yes';});
    return consent;
  };
  const ready=()=>new Promise((resolve,reject)=>{
    if(window.Shopify?.customerPrivacy){resolve(window.Shopify.customerPrivacy);return;}
    if(!window.Shopify?.loadFeatures){reject(new Error('Privacy API unavailable'));return;}
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],failure=>{
      if(failure||!window.Shopify.customerPrivacy){reject(new Error('Privacy API unavailable'));return;}
      resolve(window.Shopify.customerPrivacy);
    });
  });
  const save=async consent=>{
    const buttons=[...banner.querySelectorAll('button')];
    buttons.forEach(button=>{button.disabled=true;});
    error.hidden=true;
    try{
      api=await ready();
      await new Promise((resolve,reject)=>{
        const timeout=setTimeout(()=>reject(new Error('Consent timeout')),10000);
        api.setTrackingConsent(consent,()=>{clearTimeout(timeout);resolve();});
      });
      const stored=api.currentVisitorConsent();
      if(Object.keys(consent).some(key=>stored[key]!== (consent[key]?'yes':'no')))throw new Error('Consent not saved');
      try{localStorage.setItem('velax-cookie-choice','saved');}catch(storageError){}
      banner.hidden=true;
    }catch(failure){error.hidden=false;show();}
    finally{buttons.forEach(button=>{button.disabled=false;});}
  };
  banner.querySelector('[data-cookie-accept]').addEventListener('click',()=>save({analytics:true,marketing:true,preferences:true}));
  banner.querySelector('[data-cookie-reject]').addEventListener('click',()=>save({analytics:false,marketing:false,preferences:false}));
  banner.querySelector('[data-cookie-save]').addEventListener('click',()=>save(Object.fromEntries(inputs.map(input=>[input.dataset.cookiePurpose,input.checked]))));
  document.querySelectorAll('[data-cookie-reopen]').forEach(button=>button.addEventListener('click',async()=>{
    try{api=await ready();sync();error.hidden=true;}catch(failure){error.hidden=false;}
    show();banner.querySelector('summary').focus();
  }));
  ready().then(privacy=>{
    api=privacy;
    const consent=sync();
    let recorded=false;
    try{recorded=localStorage.getItem('velax-cookie-choice')==='saved';}catch(storageError){}
    if(!recorded||['analytics','marketing','preferences'].some(key=>consent[key]===''))show();
  }).catch(()=>{show();error.hidden=false;});
})();
